module.exports = __webpack_public_path__ + "static/media/shutterstock_537088753-reduced-jpg-60.288d8a86.jpg";